import {
  Dialog,
  DialogTitle,
  Divider,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from "@material-ui/core";
import { isBoolean } from "lodash";
import { useState } from "react";
import { useNotify } from "react-admin";
import { TenantRegistrationDto } from "../../../common/data/service-proxies";
import { ReassignTenantForm } from "./ReassignTenantForm";

interface Props {
  label: string;
  icon: JSX.Element;
  record?: TenantRegistrationDto;
  resource?: string;
  onClick?: (event: React.MouseEvent) => void;
  onSuccess?: () => void;
  hidden?: boolean | ((record: TenantRegistrationDto) => boolean);
}

export const ReassignTenantMenuItem = ({
  record,
  hidden,
  label,
  icon,
  onClick,
  onSuccess,
  ...rest
}: Props) => {
  const [isConfirmOpen, setConfirmOpen] = useState(false);
  const notify = useNotify();

  if (!record?.id) {
    return null;
  }

  if (isBoolean(hidden)) {
    if (hidden) {
      return null;
    }
  } else {
    if (hidden && hidden(record)) {
      return null;
    }
  }

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  return (
    <>
      <MenuItem
        {...rest}
        className="actions-menu-item"
        onClick={(e) => {
          setConfirmOpen(true);
          if (typeof onClick === "function") {
            onClick(e);
          }
        }}
      >
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText>{label}</ListItemText>
      </MenuItem>
      <Dialog
        open={isConfirmOpen}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>
          {`Select a customer to reassign '${record.name}' to`}
        </DialogTitle>
        <Divider />
        <ReassignTenantForm
          id={record.id}
          onSuccess={() => {
            if (onSuccess) {
              onSuccess();
            }

            notify(
              "resources.master-tenant-registrations.notifications.reassignSuccess",
              {
                type: "success",
              }
            );

            handleDialogClose();
          }}
          onFailed={handleDialogClose}
        />
      </Dialog>
    </>
  );
};
